<!-- ========== PAGE HERO ========== -->
<section class="ds-page-hero">
  <div class="ds-orb ds-orb--soft ds-page-hero__orb-1"></div>
  <div class="ds-orb ds-orb--cobalt ds-page-hero__orb-2"></div>
  <div class="container ds-page-hero__inner">
    <span class="ds-pill">İletişim</span>
    <h1>İletişime Geçin</h1>
    <p class="ds-lead">Keyo AI'ın e-ticaret sitenize nasıl değer katabileceğini öğrenmek için bizimle iletişime geçin.</p>
  </div>
</section>

<section class="ds-section ds-contact" id="contact-form">
  <div class="container">
    <div class="row g-5">
      <div class="col-lg-7">

        <form [formGroup]="contactForm" (ngSubmit)="onSubmit()" class="ds-contact-form">
          <div *ngIf="success" class="ds-alert ds-alert--success mb-3">
            <i class="fas fa-check-circle me-2"></i>
            Mesajınız başarıyla gönderildi. En kısa sürede size dönüş yapacağız.
          </div>

          <div *ngIf="error" class="ds-alert ds-alert--error mb-3">
            <i class="fas fa-exclamation-circle me-2"></i>
            Mesajınız gönderilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.
          </div>

          <div class="row g-3">
            <div class="col-md-6">
              <label for="name" class="form-label">Ad Soyad</label>
              <input
                type="text"
                class="form-control"
                id="name"
                formControlName="name"
                [ngClass]="{'is-invalid': submitted && contactForm.get('name')?.errors}"
              >
              <div *ngIf="submitted && contactForm.get('name')?.errors" class="invalid-feedback">
                <div *ngIf="contactForm.get('name')?.errors?.['required']">Ad Soyad gereklidir</div>
              </div>
            </div>

            <div class="col-md-6">
              <label for="email" class="form-label">E-posta</label>
              <input
                type="email"
                class="form-control"
                id="email"
                formControlName="email"
                [ngClass]="{'is-invalid': submitted && contactForm.get('email')?.errors}"
              >
              <div *ngIf="submitted && contactForm.get('email')?.errors" class="invalid-feedback">
                <div *ngIf="contactForm.get('email')?.errors?.['required']">E-posta gereklidir</div>
                <div *ngIf="contactForm.get('email')?.errors?.['email']">Geçerli bir e-posta adresi giriniz</div>
              </div>
            </div>

            <div class="col-12">
              <label for="company" class="form-label">Şirket</label>
              <input
                type="text"
                class="form-control"
                id="company"
                formControlName="company"
              >
            </div>

            <div class="col-12">
              <label for="message" class="form-label">Mesajınız</label>
              <textarea
                class="form-control"
                id="message"
                rows="5"
                formControlName="message"
                [ngClass]="{'is-invalid': submitted && contactForm.get('message')?.errors}"
              ></textarea>
              <div *ngIf="submitted && contactForm.get('message')?.errors" class="invalid-feedback">
                <div *ngIf="contactForm.get('message')?.errors?.['required']">Mesaj gereklidir</div>
              </div>
            </div>

            <div class="col-12">
              <button
                type="submit"
                class="btn btn-primary btn-lg position-relative"
                [disabled]="loading">
                <span [class.invisible]="loading">Gönder</span>
                <div *ngIf="loading" class="position-absolute top-50 start-50 translate-middle">
                  <div class="spinner-border spinner-border-sm text-light" role="status">
                    <span class="visually-hidden">Yükleniyor...</span>
                  </div>
                </div>
              </button>
            </div>
          </div>
        </form>
      </div>

      <div class="col-lg-5">
        <div class="ds-contact-info">
          <div class="ds-contact-card">
            <div class="ds-contact-card__icon"><i class="fas fa-map-marker-alt"></i></div>
            <h4>Adres</h4>
            <p>
              Sultan Selim Mah. Eski Büyükdere Cad.<br>
              Silahtaroğlu Sok. Yaba Plaza 2 Kat:1<br>
              4.Levent / İstanbul
            </p>
          </div>

          <div class="ds-contact-card">
            <div class="ds-contact-card__icon"><i class="fas fa-phone"></i></div>
            <h4>Telefon</h4>
            <p>
              <a href="tel:+908503099009">0850 309 9009</a>
            </p>
          </div>

          <div class="ds-contact-card">
            <div class="ds-contact-card__icon"><i class="fas fa-envelope"></i></div>
            <h4>E-posta</h4>
            <p>
              <a href="mailto:info&#64;keyodigital.com">info&#64;keyodigital.com</a><br>
              <a href="mailto:operasyon&#64;keyodigital.com">operasyon&#64;keyodigital.com</a>
            </p>
          </div>

          <div class="ds-contact-social">
            <a href="https://tr.linkedin.com/company/keyo-digital" target="_blank" aria-label="LinkedIn"><i class="fab fa-linkedin"></i></a>
            <a href="https://x.com/keyodigital" target="_blank" aria-label="X"><i class="fab fa-x-twitter"></i></a>
            <a href="https://www.instagram.com/keyodigital/" target="_blank" aria-label="Instagram"><i class="fab fa-instagram"></i></a>
            <a href="https://www.facebook.com/keyodigital/" target="_blank" aria-label="Facebook"><i class="fab fa-facebook"></i></a>
            <a href="https://youtube.com/@keyodigital" target="_blank" aria-label="YouTube"><i class="fab fa-youtube"></i></a>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
